import { render, staticRenderFns } from "./TableRanking.vue?vue&type=template&id=58cace28&scoped=true&"
import script from "./TableRanking.vue?vue&type=script&lang=js&"
export * from "./TableRanking.vue?vue&type=script&lang=js&"
import style0 from "./TableRanking.vue?vue&type=style&index=0&id=58cace28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cace28",
  null
  
)

export default component.exports